import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  ToggleButton,
  Modal
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  get_all_city,
  add_city_status,
  add_city_SoldOut,
  add_FB_Link
} from "../../../redux/actions/countryCityActions";
import { Notification } from "../../../components/notifications";
import Toggle from "react-bootstrap-toggle";
import Pagination from "react-paginating";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

import "../../../style/react-paginating.css";
import "../../../style/cityStatus/CityStatus.scss";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class CityStatus extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'CITY_LISTING',
      path: ["Home", "Manage Cities"],
      links:["home", "cityStatus"],
      cities: [],
      totalRecords: 0,
      perPage: 0,
      limit: 25,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      toggleActive: true,
      cityStatus: {},
      citySoldOut: {},
      emailSortIcon: "",
      titleSortIcon: "",
      stateSortIcon: "",
      countryNameSortIcon: "",
      direction: "",
      orderBy: "",
      show: false,
      search: "",
      default_city: "",
      cityID:"",
      AddPageLinkStatus: false,
      fb_link:"//www.facebook.com/plugins/likebox.php?href=",
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSoldOut = this.handleSoldOut.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.ShowAddPageLink = this.ShowAddPageLink.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    if(this.props.siteStatus && this.props.siteStatus.default_city){
      let default_city = this.props.siteStatus && this.props.siteStatus.default_city 
      this.setState({default_city: this.props.siteStatus.default_city})
    }
    setTimeout(this.props.get_all_city( {page: this.state.currentPage,limit:this.state.limit}), 1000);
  }

  componentWillReceiveProps(nextProps) {


    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    var cityStatusObject = new Object();
    var citySoldOutObject = new Object();
    if (this.props.cities !== nextProps.cities) {
      if (nextProps.cities) {
        const setPageCount = nextProps.cities.total / nextProps.cities.per_page;
        this.setState({
          cities: nextProps.cities.data,
          totalRecords: nextProps.cities.total,
          perPage: nextProps.cities.per_page,
          pageCount: 5,
          default_city: nextProps.cities.default_city
        });
        nextProps.cities.data.map((city, index) => {
          const id = city.cityID;
          if (city.status == "Active") {
            cityStatusObject[id] = true;
          } else if (city.status === "Inactive") {
            cityStatusObject[id] = false;
          }
          if (city.sold_out == "enable") {
            citySoldOutObject[id] = true;
          } else {
            citySoldOutObject[id] = false;
          }
        });
        this.setState({ cityStatus: cityStatusObject});
        this.setState({ citySoldOut: citySoldOutObject});
      }
    }
    if (
      this.props.cityStatus !== nextProps.cityStatus &&
      !isEmpty(nextProps.cityStatus)
    ) {
      this.setState({ show: true });
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("success", nextProps.cityStatus.message);
    }

    if (
      this.props.citySoldOut !== nextProps.citySoldOut &&
      !isEmpty(nextProps.citySoldOut)
    ) {
      this.setState({ show: true });
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("success", nextProps.citySoldOut.message);
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = e.target.value.length > 0 ? e.target.value : "";
    const postData = {
      page: 1,
      limit: 25,
      search: searchstring
    };
    if (searchstring.length > 0) {
      this.props.get_all_city(postData);
    } else {
      this.props.get_all_city({ page: this.state.currentPage,limit:this.state.limit });
    }
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_all_city({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit:this.state.limit
      });
    } else if (this.state.search !== "") {
      this.props.get_all_city({ page: page, search: this.state.search,limit:this.state.limit });
    } else {
      this.props.get_all_city({ page: page, limit:this.state.limit });
    }
  };

  handleClick = (e, id, cityStatus) => {
    const cityStatusObj = this.state.cityStatus;
    cityStatusObj[id] = !this.state.cityStatus[id];
    this.setState({ cityStatus: cityStatusObj });
    this.handleShow();
    if (cityStatusObj[id] === true) {
      this.props.add_city_status({ status: 1, cityID: id });
    } else if (cityStatusObj[id] === false) {
      this.props.add_city_status({ status: 0, cityID: id });
    }
  };

  handleSoldOut = (e, id, citySoldOut) => {
    const citySoldOutObj = this.state.citySoldOut;
    citySoldOutObj[id] = !this.state.citySoldOut[id];
    this.setState({ citySoldOut: citySoldOutObj });
    this.handleShow();
    if (citySoldOutObj[id] === true) {
      this.props.add_city_SoldOut({ status: 'enable', cityID: id });
    } else if (citySoldOutObj[id] === false) {
      this.props.add_city_SoldOut({ status: 'disable', cityID: id });
    }
  };

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.get_all_city({ orderBy: orderBy, direction: direction,limit:this.state.limit });
  };

  handleRadio = (e, id, citystatus) => {
    let status
    if(citystatus === 'Active'){
      status = "1"
    }
    else if(citystatus === 'Inactive'){
      status = "0"
    }
    this.handleShow();
    if ( e.target.value === "0") {
      this.props.add_city_status({ default_city: "1", cityID: id, status:status});
    } else if (e.target.value === "1") {
      this.props.add_city_status({ default_city: "0", cityID: id, status:status });
    }
    this.setState({default_city:id})
  };

  ShowAddPageLink = (e, cityID, fb_link) => {
    this.setState({cityID: cityID, AddPageLinkStatus: true, fb_link: (fb_link!='' && fb_link!=null ? fb_link : "//www.facebook.com/plugins/likebox.php?href=")});
  }
  
  AddPageLinkClose = (e) => {
    this.setState({cityID:"", AddPageLinkStatus:false, fb_link: "//www.facebook.com/plugins/likebox.php?href="});
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value}); 
  }
  
  handleSubmit = (e) => {
    this.props.add_FB_Link({'cityID': this.state.cityID, fb_link: this.state.fb_link});
    this.setState({AddPageLinkStatus:false});
    this.props.get_all_city({page: this.state.currentPage, limit:this.state.limit})
  }

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    const Header = [
      "City Id",
      "Title",
      "State",
      "Country Name",
      "Status",
      "View",
      "Edit",
      "Delete"
    ];
    let cityRow;
    let cities = this.state.cities ? this.state.cities : [];
    let citystatus = this.state.cityStatus ? this.state.cityStatus : [];
    let citySoldOut = this.state.citySoldOut ? this.state.citySoldOut : [];
    if (cities && citystatus) {
      cityRow = cities.map((city, index) => (
        <tr key={index}>
          <td key={`${index}_title`}>{city.title}</td>
          <td key={`${index}_state`}>{city.state}</td>
          <td key={`${index}_countryName`}>{city.countryName}</td>
          <td>
            <Toggle
              on={"Active"}
              off={"Inactive"}
              size="lg"
              responsive="true"
              offstyle="default"
              onstyle="success"
              height="30px"
              width="100px"
              active={citystatus[city.cityID]}
              onClick={e => {
                this.handleClick(e, city.cityID, city.status);
              }}
            />
          </td>
          <td>
            <label>
            <input 
            type="radio" 
            value={this.state.default_city == city.cityID ? "1" : "0"}
            checked={this.state.default_city == city.cityID ? true : false}
            onChange={e => {this.handleRadio(e, city.cityID, city.status)}} />
            Default City
          </label>
          </td>
          <td>
            <Toggle
              on={"Show"}
              off={"Hide"}
              size="lg"
              responsive="true"
              offstyle="default"
              onstyle="success"
              height="30px"
              width="100px"
              active={citySoldOut[city.cityID] ? citySoldOut[city.cityID] : false}
              onClick={e => {
                this.handleSoldOut(e, city.cityID, city.sold_out);
              }}
            />
          </td>
          <td>
            {(city.fb_link!='' && city.fb_link!=null) ?
              <React.Fragment>
                <span>{city.fb_link}</span> <br/>  
                <Button bsStyle="primary" onClick={e => {this.ShowAddPageLink(e, city.cityID, city.fb_link)}}>Update FB Page Link</Button>
              </React.Fragment>
            :
              <Button bsStyle="primary" onClick={e => {this.ShowAddPageLink(e, city.cityID, city.fb_link)}}>Add FB Page Link</Button>
            }
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <div className="col-lg-12 city-state-country-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Manage Cities</header>
            <div className="clearfix" />
            <div className="row m-t-15">
              <div className="col-lg-4 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <Glyphicon glyph="glyphicon glyphicon-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12" id="message">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="col-lg-12">
                <table className="table table-hover" responsive="true">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("title")}>
                        City<span
                          className={this.state.titleSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("state")}>
                        State<span
                          className={this.state.stateSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("countryName")}>
                        Country Name<span
                          className={this.state.countryNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Status</th>
                      <th>Default</th>
                      <th>Sold Out Deals</th>
                      <th>Facebook Page</th>
                    </tr>
                  </thead>
                  <tbody>{cityRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.AddPageLinkStatus} onHide={this.AddPageLinkClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Facebook Page Link</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormControl
              type="text"
              name="fb_link"
              value={this.state.fb_link}
              onChange={this.handleChange}
            />
            <span>Don't remove (//www.facebook.com/plugins/likebox.php?href=)</span>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleSubmit}>
              Add FB Link
            </Button>
            <Button bsStyle="danger" onClick={this.AddPageLinkClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

CityStatus.propTypes = {
  get_all_city: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  cities: state.countryCityReducers.cities,
  cityStatus: state.countryCityReducers.cityStatus,
  citySoldOut: state.countryCityReducers.citySoldOut,
  error: state.countryCityReducers.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  siteStatus: state.siteReducer.siteStatus
});

export default withRouter(connect(mapStateToProps, {
  get_all_city,
  add_city_status,
  add_city_SoldOut,
  renderAlert,
  clearAlert,
  add_FB_Link,
})(CityStatus));



// WEBPACK FOOTER //
// ./src/app/views/admin/cityStatus/CityStatus.js